var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightCompact = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.294 11.708a1.01 1.01 0 0 0 1.419 0L8.678 8.77c.215-.218.322-.5.322-.779s-.107-.556-.322-.769l-2.955-2.93a1.01 1.01 0 0 0-1.637.322.99.99 0 0 0 .218 1.084L6.62 7.995l-2.327 2.307a.99.99 0 0 0 0 1.406",
  clipRule: "evenodd"
})));
export default SvgArrowRightCompact;